module.exports = __webpack_public_path__ + "img/courses-6.6f47f204.jpg";